import { QIcon_chevron_bold_right, QIcon_chevron_right } from '@repo/icons/index'
import { Count } from '../../../../model/caf.interface'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import useWebviewNavigation from '../../../../modules/hooks/webview/common/useWebviewNavigation'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import urls from '../../../../modules/urls'
import { COLORS } from '../../../../modules/vars'
import { LESSON_ACTIVITIES_MAP, useLessonsStack } from '../../../../pages/[lang]/webview/lessons'
import Badge from '../../../common/Badge'

interface ILessonSectionPropsType {
  count: Count
  start: string
  end: string
}

const LessonSection = ({ count, start, end }: ILessonSectionPropsType) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const isWebview = useIsWebview()
  const { useLessonsFlow } = useLessonsStack()
  const { pop, push } = useLessonsFlow()
  const { navigate } = useWebviewNavigation()
  const router = useAppRouter()

  const goToLessonListPage = () => {
    if (isWebview) {
      push(LESSON_ACTIVITIES_MAP.AIStatisticLessonListActivity, { initialStartDate: start, initialEndDate: end })
    } else {
      router.push(urls.student.newPortal.myRingle.AIAnalysis.asDate(1, start, end))
    }
  }
  if (isMobile) {
    return (
      <section className="mt-[16px] w-full">
        <div onClick={goToLessonListPage}>
          <div className={styles.box}>
            <div className="flex items-center">
              <div>{t(n_caf.statistic.lessons)}</div>
              <div className="h-[12px] w-1 bg-gray-400 ml-[12px] mr-[20px]" />
              <div className={styles.right}>
                <Badge blackLight clx="pt-[2px] font-bold">
                  40{t(n_caf.highlight.min)}
                </Badge>
                <span className="text-gray-700 font-medium text-h5 ml-[4px]">{count?.forty}</span>
                <Badge blackLight clx="pt-[2px] font-bold">
                  20{t(n_caf.highlight.min)}
                </Badge>
                <span className="text-gray-700 font-medium text-h5 ml-[4px]">{count?.twenty}</span>
              </div>
            </div>
            <QIcon_chevron_right width={12} height={12} color={COLORS.GRAY600} />
          </div>
        </div>
      </section>
    )
  } else {
    return (
      <section className="mt-[16px] lg:mt-[32px] w-full">
        <div onClick={goToLessonListPage} className="w-full">
          <div className={styles.box_pc}>
            <div className="flex items-center">
              <div className="text-[16px] font-bold text-gray-700">{t(n_caf.statistic.lessons)}</div>
              <div className="h-[12px] w-1 bg-gray-400 ml-[12px] mr-[20px]" />
              <div className={styles.right}>
                <Badge blackLight clx="pt-[2px] font-bold">
                  40{t(n_caf.highlight.min)}
                </Badge>
                <span className="text-gray-700 font-medium text-[16px] ml-[4px]">{count?.forty}</span>
                <Badge blackLight clx="pt-[2px] font-bold">
                  20{t(n_caf.highlight.min)}
                </Badge>
                <span className="text-gray-700 font-medium text-[16px] ml-[4px]">{count?.twenty}</span>
              </div>
            </div>
            <div className="flex cursor-pointer items-center" onClick={goToLessonListPage}>
              <div className="mr-[4px] text-[14px] font-bold text-black">{t(n_caf.statistic.view_list)}</div>
              <QIcon_chevron_bold_right width={16} height={16} color={COLORS.GRAY600} />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default LessonSection

const styles = {
  box: `text-sBody flex items-center justify-between  rounded border bg-white p-[16px] shadow-sm`,
  box_pc: `text-sBody flex w-full items-center  justify-between rounded border bg-white p-[16px] shadow-sm`,
  right: `flex items-center gap-[20px]`,
}
